"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const Disclosure_vue_1 = tslib_1.__importDefault(require("../Disclosure.vue"));
const IsotopeHeader_vue_1 = tslib_1.__importDefault(require("../IsotopeHeader.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'registration-disclosure',
    props: {},
    data: () => {
        return {
            disclosureAccepted: false,
            userPdfCode: '',
        };
    },
    computed: {
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        canContinue() {
            // we can continue once the disclosure is accepted and the pdf code is entered (or if the pdf is disabled)
            return this.disclosureAccepted && (this.userPdfCode !== '' || !this.pdfEnabled);
        },
        disclosureContent() {
            return this.$store.state.currentChallenge.DisclosureContent || '';
        },
        disclosureID() {
            return this.$store.state.currentChallenge.DisclosureId || '';
        },
        doesDisclosureExists() {
            return this.disclosureContent !== '';
        },
        htmlBeforeDisclosure() {
            const bankName = this.$store.state.configuration.bankName;
            const isBusiness = this.$store.state.currentChallenge.IsBusiness;
            const siteTextName = `Registration.Disclosure.HtmlBefore${isBusiness ? 'Business' : ''}RegistrationDisclosure`;
            return this.getSiteText(siteTextName, bankName);
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge;
        },
        pdfUrl() {
            return this.$store.state.configuration.pdfDisclosureLocation;
        },
        hasError() {
            return (this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Success &&
                this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Unknown);
        },
        pdfCodeErrorMessages() {
            const errors = this.$store.state.errors;
            if (errors.some(er => er.CustomSubCode === 'BAD_CODE')) {
                return [this.getSiteText('Registration.PDF.Error')];
            }
            return [];
        },
        pdfEnabled() {
            return this.$store.state.currentChallenge.ShouldCheckPdf && !!this.$store.state.configuration.pdfDisclosureLocation;
        },
        isCypress() {
            return this.$store.state.isCypress;
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        async submitForm() {
            if (this.submitting || !this.disclosureAccepted) {
                return;
            }
            const challenge = {
                ...this.currentChallenge,
                DisclosureID: this.disclosureID,
                Accepted: this.disclosureAccepted,
                UserSubmittedPdfCode: this.userPdfCode,
            };
            void userTelemetry_1.telemetry.custom({
                workflowName: userTelemetry_1.workflowName.retail_registration,
                stepType: userTelemetry_1.stepType.progression,
                stepName: userTelemetry_1.stepName.disclosure,
                action: userTelemetry_1.userAction.continue_clicked,
            });
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            // submit the challenge
            await this.$store.dispatch('submitChallenge', challenge);
        },
        toggleAccepted(val) {
            this.disclosureAccepted = val;
        },
        handleTextfieldFocus(event) {
            if (this.isMobile) {
                const currentScrollPosition = window.screenY || window.pageYOffset;
                const targetField = event.target;
                const textFieldPosition = targetField.getBoundingClientRect().top;
                window.scrollTo({
                    top: currentScrollPosition + textFieldPosition,
                    behavior: 'smooth',
                });
            }
        },
        PDFOpen() {
            void userTelemetry_1.telemetry.custom({
                workflowName: userTelemetry_1.workflowName.retail_registration,
                stepType: userTelemetry_1.stepType.progression,
                stepName: userTelemetry_1.stepName.disclosure,
                action: userTelemetry_1.userAction.open_pdf_clicked,
            });
            if (this.isCypress)
                return;
            window.open(this.pdfUrl, '_blank');
        },
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        Disclosure: Disclosure_vue_1.default,
        IsotopeHeader: IsotopeHeader_vue_1.default,
    },
});
